import request from "utils/request";

import { baseRequestURL } from "api/BaseAPI";

const BASE_URL = baseRequestURL + "v1";

function recipe_request(url, options, disableAuth = false) {
  const formatted_url = `${BASE_URL}${url}`;

  return request(formatted_url, options, disableAuth);
}

export function getTraySolutions() {
  return recipe_request("/tray", {
    method: "GET"
  });
}

export function getTraySolution(solutionId) {
  return recipe_request(`/tray/${solutionId}`, {
    method: "GET"
  });
}

export function createRecipeFromTraySolution(solutionId) {
  return recipe_request(`/tray/${solutionId}/recipes`, {
    method: "POST"
  });
}

export function getRecipes() {
  return recipe_request(`/recipes`, {
    method: "GET"
  });
}

export function createRecipe(recipe) {
  return recipe_request(`/recipes`, {
    method: "POST",
    body: JSON.stringify(recipe)
  });
}

export function getRecipe(recipeId) {
  return recipe_request(`/recipes/${recipeId}`, {
    method: "GET"
  });
}

export function getRecipesBySolutionId(solutionId) {
  return recipe_request(`/tray/${solutionId}/recipes`, {
    method: "GET"
  });
}

export function updateRecipeName(recipeId, name) {
  return recipe_request(`/recipes/${recipeId}`, {
    method: "PUT",
    body: JSON.stringify({ name })
  });
}

export function deleteRecipe(recipeId) {
  return recipe_request(`/recipes/${recipeId}`, {
    method: "DELETE"
  });
}

export function createRecipeVersion(recipeId) {
  return recipe_request(`/recipes/${recipeId}/versions`, {
    method: "POST"
  });
}

export function getRecipeVersions() {
  return recipe_request(`/recipe_versions`, {
    method: "GET"
  });
}

export function getRecipeVersionsByRecipeId(recipeId) {
  return recipe_request(`/recipes/${recipeId}/versions`, {
    method: "GET"
  });
}

export function getRecipeVersion(recipeVersionId) {
  return recipe_request(`/recipe_versions/${recipeVersionId}`, {
    method: "GET"
  });
}

export function getRecipeVersionConfig(recipeVersionId) {
  return recipe_request(`/recipe_versions/${recipeVersionId}/config`, {
    method: "GET"
  });
}

export function updateRecipeVersionName(recipeVersionId, name) {
  return recipe_request(`/recipe_versions/${recipeVersionId}`, {
    method: "PUT",
    body: JSON.stringify({ name })
  });
}

export function deleteRecipeVersion(recipeVersionId) {
  return recipe_request(`/recipe_versions/${recipeVersionId}`, {
    method: "DELETE"
  });
}

export function deployRecipeVersion(recipeVersionId, deploymentId) {
  return recipe_request(`/recipe_versions/${recipeVersionId}/deployment/${deploymentId}`, {
    method: "POST"
  });
}

export function createRecipeVersionInstance(recipeVersionId, accountId, configValues) {
  return recipe_request(`/recipe_versions/${recipeVersionId}/instances`, {
    method: "POST",
    body: JSON.stringify({
      account_id: accountId,
      config_values: configValues
    })
  });
}

export function getRecipeVersionInstance(recipeVersionInstanceId) {
  return recipe_request(`/recipe_version_instances/${recipeVersionInstanceId}`, {
    method: "GET"
  });
}

export function getRecipeVersionInstances() {
  return recipe_request(`/recipe_version_instances`, {
    method: "GET"
  });
}

export function getRecipeVersionInstancesByDeploymentId(deploymentId) {
  return recipe_request(`/deployment/${deploymentId}/recipe_version_instances`, {
    method: "GET"
  });
}

export function deleteRecipeVersionInstance(recipeVersionInstanceId) {
  return recipe_request(`/recipe_version_instances/${recipeVersionInstanceId}`, {
    method: "DELETE"
  });
}
